import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { persistor, store } from '../src/states';
import Template from './Template';

const App = () => (
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <Template />
    </PersistGate>
  </Provider>
);

export default App;
